<template>
  <div>
    <SkillRadar
      :datas="skillsList"
      :fields="fields"
      child-key="jqSkillMaps"
      :options="radarOption"
      :virtual-line="virtualLineStyle"
      checkbox-color-type="marker"
      :label-style="labelStyle"
      :no-eval-planed="noEvalPlaned"
      :checkbox-style="{marginTop: skillsList.length===1 || skillsList.length % 2 ===0 ? '24px' : '0px'}"
      :close-animate="closeAnimate"
      :frontend-style="$route.meta.navCode === 1"
      @labelClick="handleClick"
    />
    <detail-dialog
      ref="detailDialog"
      :skill="selectSkill"
      tab-arr-key="jqSkillMaps"
      :title="$t('pc_gwnl_web_tit_capabilityDetails')"
      :show-skill-level="skillWithLevel"
    />
  </div>
</template>

<script>
import detailDialog from './detailDialog';
import SkillRadar from './skillRadar';

export default {
  props: {
    fields: { // 图例
      type: Array,
      default: () => []
    },
    closeAnimate: Boolean,
    hideSkillLevelBeforeEval: Boolean,
    skillWithLevel: Boolean,
    skillsList: { // 当前分类下的能力数据
      type: Array,
      default: () => []
    }
  },
  components: { detailDialog, SkillRadar },
  data() {
    return {
      selectSkill: {},
      radarOption: { height: 300, padding: [0, 0, 0, 0] },
      labelStyle: {
        cursor: 'pointer',
        appendInfo: 123
      }
    };
  },
  computed: {
    enabledFieldNames() {
      return this.fields.filter(item => item.selected).map(item => item.name);
    },
    // 虚线占位模式
    virtualLineStyle() {
      // 无能力等级或 有等级, 但开启了完成测评前不显示模型
      if ((this.hideSkillLevelBeforeEval && this.skillWithLevel) || !this.skillWithLevel) {
        return this.noEvalResult;
      }
      return false;
    },
    noEvalPlaned() { // 未安排测评
      const fieldsName = this.fields && this.fields.map(item => item.name);
      return this.noEvalProp(fieldsName);
    },
    noEvalResult() { // 未安排测评或安排了当时还没有结果
      const fieldsName = this.fields && this.fields.filter(item => item.selected).map(item => item.name);
      return this.noEvalProp(fieldsName);
    }
  },
  methods: {
    noEvalProp(fieldsNames) {
      return fieldsNames.findIndex(item => item !== 'excellentEavl' && item !== 'combStandardLevel') === -1;
    },
    handleClick(e, data) {
      this.selectSkill = data || {};
      this.$nextTick(() => {
        this.$refs.detailDialog.show();
      });
    }
  }
};
</script>
